import { Button } from '@mui/material';
import React from 'react';

const TaxSavingButton = ({ variant, textKey, onClick, isPresent, t }) => {
  if (!isPresent) {
    return null;
  }
  return (
    <Button
      variant={variant}
      sx={(theme) => ({
        bgcolor: theme.palette.secondary.main,
        color: '#ffffff',
        textTransform: 'none',
        borderRadius: '15px',
        borderColor: '#DCE4E8',
        fontWeight: '700',
        padding: '8px 12px',
        '&:hover': {
          bgcolor: theme.palette.secondary.main + 'CC',
        },
        flex: 1,
      })}
      onClick={onClick}
    >
      {t(textKey)}
    </Button>
  );
};

export default TaxSavingButton;
